import SignupForm from "../SignupForm";

const ForgotPass = () => {

    return (
        <SignupForm
            url="/account/reset-password"
        />
    );
};

export default ForgotPass;